import { Popconfirm, Tag } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { getTagColor } from '../../../../../../helpers/getTagColor'
import { useTranslation } from 'react-i18next'

export const TagWithActionConfirm = ({ code, onDeleteTag }: { code: string; onDeleteTag: () => void }) => {
  const [openFor, setOpenFor] = useState<string | null>(null)
  const { t } = useTranslation()

  return (
    <Tag color={getTagColor(code)} closable={false}>
      {code}
      <Popconfirm
        open={openFor === code}
        onOpenChange={(open) => setOpenFor(open ? code : null)}
        title={t('patientInfo.tags.popconfirm.title')}
        description={t('patientInfo.tags.popconfirm.description')}
        onConfirm={() => {
          onDeleteTag()
          setOpenFor(null)
        }}
        onCancel={() => setOpenFor(null)}
        placement="topLeft"
        okText={t('common.yes')}
        cancelText={t('common.no')}
      >
        <CloseOutlined
          style={{ marginLeft: 8, cursor: 'pointer' }}
          onClick={(e) => {
            e.stopPropagation() // prevent tag click/selection
            setOpenFor(code)
          }}
        />
      </Popconfirm>
    </Tag>
  )
}
